











import Vue from 'vue'
export default Vue.extend({
  name: 'IconFlag',
  props: {
    color: {
      type: String,
      default: 'white',
    },
  },
})
